define.alias("ember-cli-string-helpers/helpers/w", "settings/helpers/w");